@if (
    {
        isIntegration: isIntegration$ | async,
        isLybera: isLybera$ | async,
        isViaLiberaDeposit: isViaLiberaDeposit$ | async
    };
    as data
) {
    @if (!data.isIntegration && !data.isLybera) {
        <div class="app-user-context-menu-avatar">
            @if (isAdmin) {
                <bil-avatar rounded icon="far fa-user-crown"></bil-avatar>
            } @else {
                <bil-avatar rounded icon="far fa-user"></bil-avatar>
            }
        </div>
    }
    @if (!data.isIntegration && !data.isLybera) {
        <div class="app-user-context-menu-name">
            {{ username }}
        </div>
    }
    @if (!data.isIntegration && !data.isLybera) {
        <button
            (click)="toggleDrawer()"
            class="app-user-context-menu-toggle"
            joyrideStep="manage11"
            [stepContent]="tour.customContent"
            [stepContentParams]="{
                descr: descrUtente,
                title: 'Menù utente',
                link: 'dashboardVideo'
            }"
        >
            <bil-icon
                [name]="isVisible ? 'far fa-times' : 'far fa-ellipsis-h'"
            ></bil-icon>
        </button>
    }
    @if (isVisible) {
        <bil-drawer-menu
            [fullScreen]="data.isIntegration || data.isLybera"
            [left]="data.isIntegration || data.isLybera"
        >
            @if (!data.isViaLiberaDeposit) {
                <bil-drawer-menu-item (click)="hideDrawer()" to="/user/profile">
                    Visualizza profilo
                </bil-drawer-menu-item>
            }
            @if (!data.isViaLiberaDeposit) {
                <bil-drawer-menu-item
                    *ngxPermissionsOnly="'ADMIN'"
                    (click)="hideDrawer()"
                    to="/manage/users"
                >
                    Gestisci gli utenti
                </bil-drawer-menu-item>
            }
            @if (
                !data.isViaLiberaDeposit &&
                isAdmin &&
                !(data.isIntegration || data.isLybera)
            ) {
                <bil-drawer-menu-item
                    (click)="hideDrawer()"
                    to="/manage/permissions"
                >
                    Assegna i permessi
                </bil-drawer-menu-item>
            }
            @if (!data.isIntegration && !data.isLybera) {
                <bil-drawer-menu-item position="bottom">
                    <bil-button color="primary" (onClick)="doLogout()">
                        <bil-icon name="far fa-sign-out"></bil-icon>
                        Logout
                    </bil-button>
                    <!-- <bil-icon name="far fa-sign-out"></bil-icon>
          Logout -->
                </bil-drawer-menu-item>
            }
        </bil-drawer-menu>
    }
}
